<fullscreen-page>
  <content-column look="light">
    <div class="d-flex flex-column h-100 p-2" slot="content">
      <dx-data-grid
        [allowColumnReordering]="true"
        [allowColumnResizing]="true"
        [dataSource]="catalogManufaturerNames"
        [height]="'100%'"
        [repaintChangesOnly]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        class="flex-grow-1 overflow-hidden"
        id='manufacturerGrid'
      >
        <dxo-load-panel [enabled]="true"></dxo-load-panel>
        <dxo-search-panel [visible]="true" [width]="240" placeholder="Suche …"></dxo-search-panel>
        <dxo-search [enabled]="true"></dxo-search>
        <dxi-column caption="{{ 'Im Katalog' | translate }}" dataField="manufacturerName"></dxi-column>
        <dxi-column caption="{{ 'Datenquelle' | translate }}" cellTemplate="dataSourceDropDownTemplate">
          <div *dxTemplate="let cell of 'dataSourceDropDownTemplate'">
            <dx-select-box
              (onValueChanged)="changeDataSource(cell.data, $event.value)"
              [(value)]="cell.data.currentId"
              [dataSource]="customerProductDataSourcesPaged"
              [displayExpr]="displayCustomerSource"
              [dropDownOptions]="dropDownCfg"
              [searchEnabled]="true"
              valueExpr="id"/>
          </div>
        </dxi-column>
      </dx-data-grid>
      <dx-load-panel
        [focusStateEnabled]="false"
        [position]="{ of: '#manufacturerGrid' }"
        [shading]="false"
        [showIndicator]="true"
        [visible]="isLoading"
      ></dx-load-panel>
      <div class="d-flex justify-content-end mt-2">
        <dx-button (onClick)="apply()" stylingMode="contained" text="Anwenden" type="default"></dx-button>
      </div>
    </div>
  </content-column>
  <np-edit-datasource
    (saved)="onEditSaved($event)"
    [(visible)]="popupVisible"
    [dataSource]="newAddedDatasource"
    [editMode]="false"
  ></np-edit-datasource>
</fullscreen-page>
